import { Outlet, useLocation } from 'react-router-dom'
import { DashboardContainer } from '../Dashboard'
import { SideNav } from './SideNav'

const Settings = () => {
   const location = useLocation()
   const isStageMapping = location.pathname.includes('stage-mapping')

   return (
      <>
         <DashboardContainer>
            <div className="flex gap-5">
               <div className={`flex rounded-lg bg-[#9061DA]/[0.05] w-full h-[calc(100vh-120px)] ${isStageMapping ? '' : 'max-w-[1064px]'}`}>
                  <SideNav />
                  <div className="flex-1 overflow-hidden h-full flex flex-col">
                     <Outlet />
                  </div>
               </div>
            </div>
         </DashboardContainer>
      </>
   )
}

export default Settings
